import { render, staticRenderFns } from "./istatistik.vue?vue&type=template&id=d3e8da26&"
import script from "./istatistik.vue?vue&type=script&lang=js&"
export * from "./istatistik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports